"use strict";
/* eslint-disable */
// @ts-nocheck
// GENERATED FILE - DO NOT EDIT!
// Generated by tools/gen-ts-from-proto (gotemplates/grpc-web-redux-saga)
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorSWServer = exports.GRPCWebSWServer = exports.ackServerMessage = exports.serverMessageStreaming = exports.IAckServerMessageRequest_toProto = exports.IAckServerMessageRequest_fromProto = exports.IServerMessages_toProto = exports.IServerMessages_fromProto = exports.IServerMessage_toProto = exports.IServerMessage_fromProto = exports.IServerMessageStreamingRequest_toProto = exports.IServerMessageStreamingRequest_fromProto = void 0;
var tslib_1 = require("tslib");
var server_pb = tslib_1.__importStar(require("../../../../../../../lib/generated/apis/sparx/messaging/server/v1/server_pb"));
var protoUtils_1 = require("../../../../../../protoUtils");
var server_pb_service_1 = require("./server_pb_service");
exports.IServerMessageStreamingRequest_fromProto = function (msg) {
    return msg && {
        sessionID: msg.getSessionId(),
    };
};
exports.IServerMessageStreamingRequest_toProto = function (obj) {
    var msg = new server_pb.ServerMessageStreamingRequest();
    if (obj.sessionID !== undefined) {
        msg.setSessionId(obj.sessionID);
    }
    return msg;
};
exports.IServerMessage_fromProto = function (msg) {
    return msg && {
        type: msg.getType(),
        payload: msg.getPayload(),
    };
};
exports.IServerMessage_toProto = function (obj) {
    var msg = new server_pb.ServerMessage();
    if (obj.type !== undefined) {
        msg.setType(obj.type);
    }
    if (obj.payload !== undefined) {
        msg.setPayload(obj.payload);
    }
    return msg;
};
exports.IServerMessages_fromProto = function (msg) {
    return msg && {
        messages: msg.getMessagesList().map(function (submsg) { return exports.IServerMessage_fromProto(submsg); }),
    };
};
exports.IServerMessages_toProto = function (obj) {
    var msg = new server_pb.ServerMessages();
    if (obj.messages !== undefined) {
        msg.setMessagesList(obj.messages.map(function (subobj) { return exports.IServerMessage_toProto(subobj); }));
    }
    return msg;
};
exports.IAckServerMessageRequest_fromProto = function (msg) {
    return msg && {
        messageID: msg.getMessageId(),
    };
};
exports.IAckServerMessageRequest_toProto = function (obj) {
    var msg = new server_pb.AckServerMessageRequest();
    if (obj.messageID !== undefined) {
        msg.setMessageId(obj.messageID);
    }
    return msg;
};
exports.serverMessageStreaming = protoUtils_1.streamingEndpoint(server_pb_service_1.SWServer.ServerMessageStreaming, exports.IServerMessageStreamingRequest_toProto, exports.IServerMessages_fromProto);
exports.ackServerMessage = protoUtils_1.unaryEndpoint(server_pb_service_1.SWServer.AckServerMessage, exports.IAckServerMessageRequest_toProto, protoUtils_1.emptyPbToEmptyObject);
var GRPCWebSWServer = /** @class */ (function () {
    function GRPCWebSWServer(host, metadata) {
        var _this = this;
        this.host = host;
        this.metadata = metadata;
        this.serverMessageStreaming = function (req, metadata) {
            var requestMetadata = protoUtils_1.mergeMetadata(_this.metadata, metadata);
            return exports.serverMessageStreaming(_this.host, req, requestMetadata);
        };
        this.ackServerMessage = function (req, metadata) {
            var requestMetadata = protoUtils_1.mergeMetadata(_this.metadata, metadata);
            return exports.ackServerMessage(_this.host, req, requestMetadata);
        };
    }
    return GRPCWebSWServer;
}());
exports.GRPCWebSWServer = GRPCWebSWServer;
var ErrorSWServer = /** @class */ (function () {
    function ErrorSWServer() {
        this.serverMessageStreaming = function (req, metadata) {
            return new Error('Endpoint is unimplemented');
        };
        this.ackServerMessage = function (req, metadata) {
            return new Error('Endpoint is unimplemented');
        };
    }
    return ErrorSWServer;
}());
exports.ErrorSWServer = ErrorSWServer;
